export function Card({
  children,
  className = "",
  onClick,
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}) {
  return (
    <div
      onClick={onClick}
      role={onClick ? "button" : undefined}
      className={`bg-surface-primary rounded-[10px] border-[0.5px] border-border-secondary p-8 shadow-customCard ${className}`}
    >
      {children}
    </div>
  );
}
